import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from 'assets/icons/insights/close-icon.svg?react';
import { ChangeEvent, FC, memo, useCallback, useState } from 'react';
import { useAnalytics } from 'services/analytics';
import { RATING_STARS_COUNT } from 'utils';

import StarDefaultIcon from '../../assets/star-default.svg?react';
import StarFilledIcon from '../../assets/star-filled.svg?react';
import { closeButtonSx, primaryButtonSx, starContainerSx, subtitleSx, textareaSx, titleSx } from './styles';

type TFeedbackStepProps = {
  rating: number;
  onSubmit: (comment: string) => void;
  onClose: () => void;
  placement?: string;
  day?: number;
};

export const FeedbackStep: FC<TFeedbackStepProps> = memo(({ rating, onSubmit, onClose, placement, day }) => {
  const { trackEvent } = useAnalytics();
  const [comment, setComment] = useState('');

  const handleSubmit = (): void => {
    trackEvent('app_feedback_feedback_shared', {
      ...(placement && { placement }),
      ...(day && { day }),
      source: 'web',
      rating,
      comment: comment.trim(),
    });
    onSubmit(comment.trim());
  };

  const handleChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>): void => {
    setComment(e.target.value);
  }, []);

  return (
    <Stack sx={{ gap: 6, alignItems: 'center' }}>
      <IconButton sx={closeButtonSx} onClick={onClose}>
        <CloseIcon />
      </IconButton>

      <Stack sx={starContainerSx}>
        {Array.from({ length: RATING_STARS_COUNT }).map((_, i) => (
          <Box key={i} display="flex" alignItems="center">
            {rating > i ? <StarFilledIcon /> : <StarDefaultIcon />}
          </Box>
        ))}
      </Stack>

      <Stack sx={{ gap: 2, alignItems: 'center' }}>
        <Typography sx={titleSx}>Sorry to hear that!</Typography>
        <Typography sx={subtitleSx}>We love knowing what we can improve.</Typography>
      </Stack>

      <Box component="textarea" placeholder="Leave a comment" value={comment} onChange={handleChange} sx={textareaSx} />

      <Button sx={primaryButtonSx} disabled={!comment.trim()} onClick={handleSubmit}>
        Continue
      </Button>
    </Stack>
  );
});
